import React, { useState, useEffect } from "react";
import { View, StyleSheet, TouchableOpacity, Text } from "react-native";
import MobileBackButton from "./MobileBackButton";

/**
 * Mobile Simulator Component
 * Wraps content in a phone-sized frame for desktop development
 */
const MobileSimulator = ({ children }) => {
  const isDevelopment = process.env.NODE_ENV === "development";
  const isDesktop = window.innerWidth >= 768;

  // Get initial state from localStorage or default to false (desktop view)
  const [showSimulator, setShowSimulator] = useState(() => {
    const saved = localStorage.getItem("mobileSimulatorEnabled");
    return saved !== null ? saved === "true" : false;
  });

  // Save state to localStorage when it changes
  useEffect(() => {
    localStorage.setItem("mobileSimulatorEnabled", showSimulator.toString());
  }, [showSimulator]);

  // Toggle simulator view
  const toggleSimulator = () => {
    setShowSimulator(!showSimulator);
  };

  // On desktop, never show simulator - just render children directly
  if (isDesktop) {
    return (
      <>
        {children}
        <MobileBackButton />
      </>
    );
  }

  // Only show simulator in development on mobile AND if enabled
  if (!isDevelopment || !showSimulator) {
    return (
      <>
        {children}
        <MobileBackButton />
      </>
    );
  }

  return (
    <View style={styles.simulatorContainer}>
      {/* Toggle to Desktop View Button */}
      <TouchableOpacity dataSet={{ hover: "lift" }} style={styles.backButton} onPress={toggleSimulator}>
        <Text style={styles.backButtonText}>← Desktop View</Text>
      </TouchableOpacity>

      {/* Phone Frame */}
      <View style={styles.phoneFrame}>
        {/* Top Notch (iPhone style) */}
        <View style={styles.notch} />

        {/* Screen Content */}
        <View style={styles.screen}>
          {children}
          <MobileBackButton />
        </View>

        {/* Bottom Home Indicator */}
        <View style={styles.homeIndicator} />
      </View>

      {/* Device Label */}
      <View style={styles.deviceLabel}>
        <span style={styles.labelText}>
          📱 iPhone 12/13 Pro Simulator (390x844)
        </span>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  simulatorContainer: {
    flex: 1,
    backgroundColor: "#0F1A19",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 20,
  },
  backButton: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 6,
    marginBottom: 20,
    cursor: "pointer",
  },
  backButtonText: {
    color: "#FFFFFF",
    fontSize: 14,
    fontWeight: "600",
  },
  phoneFrame: {
    width: 390,
    height: 844,
    backgroundColor: "#0F1A19",
    borderRadius: 40,
    overflow: "hidden",
    position: "relative",
    boxShadow: "0 4px 12px rgba(15, 26, 25, 0.1), 0 28px 64px rgba(15, 26, 25, 0.18)",
    elevation: 20,
    borderWidth: 12,
    borderColor: "#0F1A19",
  },
  notch: {
    position: "absolute",
    top: 0,
    left: "50%",
    marginLeft: -75,
    width: 150,
    height: 30,
    backgroundColor: "#0F1A19",
    borderBottomLeftRadius: 14,
    borderBottomRightRadius: 14,
    zIndex: 10,
  },
  screen: {
    flex: 1,
    backgroundColor: "#FFFFFF",
    overflow: "hidden",
  },
  homeIndicator: {
    position: "absolute",
    bottom: 8,
    left: "50%",
    marginLeft: -70,
    width: 140,
    height: 5,
    backgroundColor: "#2E3A38",
    borderRadius: 3,
    zIndex: 10,
  },
  deviceLabel: {
    marginTop: 20,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 6,
  },
  labelText: {
    color: "#FFFFFF",
    fontSize: 14,
    fontWeight: "600",
  },
  toggleButton: {
    position: "fixed",
    top: 10,
    right: 10,
    backgroundColor: "#0E7C6B",
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 5,
    zIndex: 9999,
    cursor: "pointer",
    boxShadow: "0 1px 2px rgba(15, 26, 25, 0.06), 0 2px 8px rgba(15, 26, 25, 0.06)",
    elevation: 5,
  },
  toggleButtonText: {
    color: "#FFFFFF",
    fontSize: 12,
    fontWeight: "600",
  },
});

export default MobileSimulator;
